import { c as _c } from "react/compiler-runtime";
import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import BrandCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/BrandCard';
import ClarityCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/ClarityCard';
import ConsultingCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/ConsultingCard';
import CustomerSuccessCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/CustomerSuccessCard';
import FGQuoteCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/FGQuoteCard';
import FundableCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/FundableCard';
import OfficeHoursCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/OfficeHoursCard';
import PodcastReviewCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/PodcastReviewCard';
import SocialVideoCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/SocialVideoCard';
import StatsCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/StatsCard';
import TrustPilotCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/TrustPilotCard';
import WorkshopsCard from '@src/components/sco/InvestorOutreachLP/components/cards/social/WorkshopsCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';

// Function to render the correct card component based on the type
export const renderCardComponent = (cardData, index) => {
  switch (cardData.type) {
    case 'StatsCard':
      return <StatsCard key={index} {...cardData} />;
    case 'BrandCard':
      return <BrandCard key={index} {...cardData} />;
    case 'FGQuoteCard':
      return <FGQuoteCard key={index} stackProps={{
        bgColor: 'colorPalette.container'
      }} {...cardData} />;
    case 'WorkshopsCard':
      return <WorkshopsCard key={index} {...cardData} />;
    case 'OfficeHoursCard':
      return <OfficeHoursCard key={index} stackProps={{
        bgColor: 'colorPalette.container'
      }} {...cardData} />;
    case 'SocialVideoCard':
      return <SocialVideoCard key={index} {...cardData} />;
    case 'PodcastReviewCard':
      return <PodcastReviewCard key={index} stackProps={{
        bgColor: 'colorPalette.container'
      }} {...cardData} />;
    case 'CustomerSuccessCard':
      return <CustomerSuccessCard key={index} {...cardData} />;
    case 'ClarityCard':
      return <ClarityCard key={index} {...cardData} />;
    case 'FundableCard':
      return <FundableCard key={index} {...cardData} />;
    case 'ConsultingCard':
      return <ConsultingCard key={index} {...cardData} />;
    case 'TrustPilotCard':
      return <TrustPilotCard key={index} {...cardData} />;
    default:
      return null;
  }
};
const MasonryGrid: React.FC<{
  cards: React.ReactNode[];
}> = t0 => {
  const $ = _c(5);
  const {
    cards
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== cards || $[1] !== getBreakpointValue) {
    const columnCount = getBreakpointValue({
      base: 1,
      sm: 1,
      md: 2,
      lg: 2,
      xl: 3
    }) || 3;
    const cardsPerColumn = getBreakpointValue({
      base: cards.length,
      sm: 2,
      md: 3,
      lg: 3,
      xl: 5
    }) || 5;
    const columns = Array.from({
      length: columnCount
    }, _temp);
    cards.forEach((card, index) => {
      const columnIndex = Math.floor(index / cardsPerColumn) % columnCount;
      columns[columnIndex].push(card);
    });
    let t2;
    if ($[3] !== getBreakpointValue) {
      t2 = getBreakpointValue([24, 0]);
      $[3] = getBreakpointValue;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = <SimpleGrid columns={columnCount} gap={5} marginBottom={t2} width="full" zIndex={1}>{columns.map(_temp3)}</SimpleGrid>;
    $[0] = cards;
    $[1] = getBreakpointValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MasonryGrid;
function _temp() {
  return [];
}
function _temp2(card_0, cardIndex) {
  return <Box key={cardIndex} width="full">{card_0}</Box>;
}
function _temp3(columnCards, i) {
  return <VStack key={i} gap={5}>{columnCards.map(_temp2)}</VStack>;
}